import {
   ASSETS_BASE_URL,
   COMMON_BASE_URL_PREFIX
} from '@flowwai-frontend/shared/constants'

export const AP_MAUD_RIGHT_SIDE_BG_IMG = `${ASSETS_BASE_URL}/common/login/ap_maud_background_pattern.png`
export const AP_PLACES_BOTTOM_BANNER = `${ASSETS_BASE_URL}/common/login/ap_maud_buildings.png`
export const AP_MAUD_MAP_IMAGE_URL = `${ASSETS_BASE_URL}/common/login/ap_map.png`
export const AP_PLACES_TOP_BANNER = `${ASSETS_BASE_URL}/common/login/ap_maud_login_top.png`

export const LOGIN_BG_IMG = `${ASSETS_BASE_URL}/common/images/citizen_background_login_v2.png`

// Field Reference IDs
export const USER_CUSTOM_KML_MAP_STYLE = 'USER_CUSTOM_KML_MAP_STYLE'

export const FALLBACK_PROFILE_PIC_URL = `${COMMON_BASE_URL_PREFIX}/no-profile-pic.png`
